import React from 'react'

const DownloadTemplate = () => {

    const downloadCSV = () => {
        const link = document.createElement('a');
        link.href = `/template/listCheckHotline.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return <>
        <label>Get file template input <span className="cursor-pointer text-primary"
                                             onClick={() => downloadCSV()}>here</span></label>
    </>
}

export default DownloadTemplate
